import get from "lodash/get";
import { defaultObject } from "redux-store/selectors";

function getFeatureFlags(state) {
  return get(state, "global.featureFlags.flags", defaultObject);
}

export { getFeatureFlags };
